import { render, staticRenderFns } from "./SchoolIndexView.vue?vue&type=template&id=79a7bfa0"
import script from "./SchoolIndexView.vue?vue&type=script&lang=js"
export * from "./SchoolIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports